export const G_elements = new Map();